import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { faNetworkWired, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckLg, DashCircle, ExclamationTriangle, Pencil, PencilFill, PlusSquareFill } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { Fragment, useEffect, useState } from "react";
import { getCustomerGroups, addEditCustomerGroup, deleteCustomerGroup } from "../store/api/CustomerApi";
import { isWebApp, setDialog, translateError } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
const ModalAddEditCustomerGroups = (props) => {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const { show } = popData;
    const [currGroup, setCurrGroup] = useState(null);
    const [submitError, setSubmitError] = useState(null);
    const [groupList, setGroupList] = useState({ Data: [] });
    function close() {
        setPopData({
            show: false
        })
        setSubmitError(null);
    }
    const tableCols = [
        { colTitle: "نام گروه", colName: "Group", justInMobile: true },
        { colTitle: "ترتیب نمایش", colName: "ItemOrder", justInMobile: true },
        { colTitle: "کداشتراک اجباری", colName: "RequiredSubscriptionCode", colType: "boolean", justInMobile: true }
    ]
    const rowButtons = [
        { title: "ویرایش گروه", type: "common", icon: <PencilFill color="orange" size="18" />, className: "group-Btn-smalll", onclick: setForEdit },
        {
            title: "حذف گروه", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف گروه',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteCustomerGroup(item.ID, onDelete)
                }))
            }
        }
    ]
    function onDelete(res)
    {
        if(res.Error)
        {
            setSubmitError(translateError(res.Error));
            
        }
        else if (res.Data)
        {
            setGroupList(res);
        }
    }
    function setForAdd() {
        const order  = groupList?.Data && Array.isArray(groupList.Data) ? groupList.Data.length+1 :0;
        setCurrGroup({ ID: 0, ItemOrder:order });
    }
    function setForEdit(group) {
        if (group.e) {
            delete group.e;
        }
        setCurrGroup(group);
    }
    function cancel() {
        setCurrGroup(null);
        setSubmitError(null);
    }
    function onSubmit() {
        setSubmitError(null);
        if ((currGroup.Group ?? "") === "") {
            setSubmitError("نام گروه وارد نشده است");
        }
        if ((currGroup.ItemOrder ?? "") === "") {
            setSubmitError("ترتیب نمایش وارد نشده است");
        }
        const onSuccess = (res)=>{
            if(res.Error)
            {
                setSubmitError(translateError(res.Error));
                return;
            }
            else if(res.Data)
            {
                setGroupList(res);
                setCurrGroup(null);
            }
        }
        addEditCustomerGroup(currGroup, onSuccess);        
    }
    useEffect(() => {
        if (show) {
            getCustomerGroups(setGroupList);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faNetworkWired} size="lg" />&nbsp;
                    مدیریت گروه های مشتری
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {currGroup &&
                    <Row className="rowBorder">
                        <Col md={4} className="form-group" style={{ padding: "2px", paddingRight: "5px" }}>
                            <label>نام گروه: </label>
                            <Form.Control onChange={e => currGroup.Group = e.target.value} defaultValue={currGroup.Group ?? ""} />
                        </Col>
                        <Col md={3} className="form-group" style={{ padding: "2px" }}>
                            <label>ترتیب نمایش</label>
                            <Form.Control type="number" onChange={e => currGroup.ItemOrder = e.target.value} defaultValue={currGroup.ItemOrder ?? ""} />
                        </Col>
                        <Col md={5} className="form-group" style={{ padding: "2px", maxWidth: "max-content" }}>
                            <div className="rowBorder" style={{ padding: "8px", marginTop: isWebApp() ? "24px" : "0px" }}>
                                <input type="checkbox" className="form-check-input" onChange={e => currGroup.RequiredSubscriptionCode = e.target.checked} defaultChecked={currGroup.RequiredSubscriptionCode ?? false} /> &nbsp;
                                <label>کد اشتراک اجباری</label>
                            </div>
                        </Col>
                        <div className="mt-2">
                            <Button className="group-Btn" variant="info" onClick={onSubmit}>
                                {
                                    Number(currGroup.ID) === 0 &&
                                    <Fragment>
                                        <CheckLg size={16} />&nbsp; ثبت گروه جدید
                                    </Fragment>
                                }
                                {
                                    Number(currGroup.ID) > 0 &&
                                    <Fragment>
                                        <Pencil size={16} />&nbsp; ویرایش گروه
                                    </Fragment>
                                }
                            </Button>
                            <Button className="group-Btn" variant="danger" onClick={cancel}><DashCircle size={17} />&nbsp;انصراف</Button>
                        </div>
                    </Row>}
                {submitError &&
                    <Alert variant="danger">
                        <ExclamationTriangle size={18} />&nbsp; {submitError}
                        <FontAwesomeIcon size="lg" icon={faTimes} style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>}
                  {!currGroup &&  <PlusSquareFill size={25} color="#4c4caf" className="hoverIcon" onClick={setForAdd}/>}
                <BihamtaTable dataList={groupList} columns={tableCols} rowButtons={rowButtons} />
            </Modal.Body>
        </Modal>
    )

}
export default ModalAddEditCustomerGroups;